
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assistants",
      function () {
        return require("private-next-pages/assistants.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assistants"])
      });
    }
  